//
import Model from '@/models/Model'

/**
 * This class describes sl ground seller sales.
 * @class      SlGroundSellerSales (name)
 */
export default class SlGroundSellerSale extends Model {

	/**
	 * { property_description }
	 * @type {<type>}
	 */
	get customer_branch_offices() {
		return this.getProperty('sl_customer_branch_offices', '-')
	}

	/**
	 * Fetches an excel.
	 * @param  {<type>}  [params={}]  The parameters
	 * @return {<type>}  The excel.
	 */
	fetchExcel(params = {}) {
		return this
			.excel('', params)
			.then(this.showFile('excel', 'xlsx'))
	}

	/**
	 * { function_description }
	 * @return {string}  { description_of_the_return_value }
	 */
  resource() {
    return 'sl_ground_seller_sale'
  }
}
